/* eslint-disable jsdoc/check-param-names */
import React, { useEffect } from 'react';
import { BackendErrorAlert } from './BackendErrorAlert.jsx';
import { parseChangeErrorResponse } from '../../utils/_helpers';

/**
 * Error alert displayed when an error occurs when changing data (POST) in backend/SAP
 * @param { boolean} open
 * @param {function(): void} handleClose
 * @param {string} errorMessage
 * @returns {React.ReactElement}
 * @class
 */
export const ChangeErrorAlert = ({ open, handleClose, errorMessage }) => {
    // parse error JSON
    const error = parseChangeErrorResponse(errorMessage);
    const isSapError = error.sapErrorMessage !== undefined;

    useEffect(() => {
        if (isSapError) {
            console.log('errorMessage', error);
        } else {
            console.log('errorMessage', errorMessage);
        }
    }, []);

    let title;
    let explanation = BackendErrorAlert.CHANGE_EXPLANATION;
    let smallLine1;
    let smallLine2;

    // missing role error
    if (error.sapErrorCode === '/GLB/YGTPP_AMS_UTIL/023') {
        title = 'Error.';
        explanation = 'Approver could not be added.';
        smallLine1 = 'They do not have the SAP PR and EasyBuy Business Approver role assigned to their profile.';
        // prettier-ignore
        smallLine2 = <a href={"https://amigo.nestle.com/LORA/page.axd?RuntimeFormID=fb38c1f7-cda6-4cea-ab42-8cc5a553081f&aeweb_handler=p&aeweb_rp=&wproj=0&MenuID=Portal_IAM_MyIdentity&ContextID=CCC_ITShop_ProductSelection"} target="_blank" rel="noreferrer">You can raise a request by following this link</a>;
    }
    // approver already existing for level
    else if (error.sapErrorCode === '/GLB/YGTPP_AMS_UTIL/026') {
        title = 'Error.';
        explanation = 'Approver could not be added.';
        smallLine1 = error.sapErrorMessage;
    } else {
        // SAP backend error OR Olympe backend error (such as remote action timeout)
        smallLine1 = isSapError ? error.sapErrorMessage : errorMessage;
    }

    return (
        <BackendErrorAlert
            open={open}
            onClose={handleClose}
            title={title}
            mainLine={explanation}
            smallLine1={smallLine1}
            smallLine2={smallLine2}
        />
    );
};
